import moment from 'moment';
import sysMsgs from '@/helpers/system.message'
import formatCurrency from '@/helpers/utils'
import {
  validate,
  clean,
  format
} from 'rut.js'
import apiPayments from '@/services/finance.services'

let now = moment().format("YYYY-MM-DD");
let lastMonth = moment(moment().subtract(2, 'months').calendar()).format("YYYY-MM-DD")

export default {
  name: "Payments",
  data() {
    return {
      loading: false,
      noResults: false,
      controller: {
        title: "Finanzas",
        mainRouter: "/finanzas/pagos"
      },
      searchQry: {
        search: '',
        fecha_i: '',
        fecha_f: now
      },
      payments: [],
      now: now,
      lastMonth: lastMonth
    };
  },
  computed: {
    disableSearch() {
      return this.validSearch && this.searchQry.fecha_i.trim().length > 0 && this.searchQry.fecha_f.trim().length > 0;
    },
    isOC() {
      return this.searchQry.search.trim().toUpperCase().startsWith('OC_');
    },
    isOC_Servipag() {
      return this.searchQry.search.trim().toUpperCase().startsWith('SP_');
    },
    isRut() {
      return validate(this.searchQry.search);
    },
    validSearch() {
      return this.searchQry.search.trim().length > 7; //&& (this.isOC || this.isRut || this.isOC_Servipag)
      //return true
    }
  },
  filters: {
    currency(val) {
      return formatCurrency.currency(val)
    },
    formatDateTime(val) {
      return moment(val).format('DD-MM-YYYY, h:mm:ss a')
    }
  },
  methods: {
    searchPayments() {
      this.loading = true;
      apiPayments.getPayments(this.searchQry).then(response => {
        this.payments = response.data.pagos;
        this.loading = false;
        this.noResults = false;
      }).catch(error => {
        sysMsgs.getResponseMessage(error.response);
        this.payments = [];
        this.noResults = true;
        this.loading = false;
      });
    },
    checkIfOC(arr) {
      //comprueba si existen transacciones en el pago.
      return arr.some(i => i.oc != '0');
    },
    checkIfPaymentIsValid(resCode, date) {
      /*
       * @param resCode => responseCode de la transacción
       * @param date => fecha de finalización de la transacción
       * @return Bool
       * 
       * Validamos si la transacción está aprobada si cumple las siguientes condiciones.
       * 1) El Codigo de respuesta es igual a cero
       * 2) La fecha de finalización de la transacción no viene vacía o nula
       * 3) El año en la fecha de finalización de la transacción es diferente a 1900
       */

      return resCode == 0 && moment(date).isValid() && moment(date).format('YYYY') !== "1900";
    },
    clean() {
      this.payments = [];
      this.searchQry = {
        search: '',
        fecha_i: '',
        fecha_f: now
      }
    }
  }
};